import BetRadarMobileWidgetCollapsed from "app/components/BetRadarMobileWidgetCollapsed/BetRadarMobileWidgetCollapsed";
import BetRadarMobileWidgetExpanded from "app/components/BetRadarMobileWidgetExpanded/BetRadarMobileWidgetExpanded";
import { EventType } from "app/types/eventType";

type Props = {
  sourceFixtureId: string;
  event: EventType;
  widgetExpanded: boolean;
};

const BetradarWidgetMobile = ({
  widgetExpanded,
  sourceFixtureId,
  event,
}: Props) => {
  return widgetExpanded ? (
    <BetRadarMobileWidgetExpanded
      event={event}
      sourceFixtureId={sourceFixtureId}
    />
  ) : (
    <BetRadarMobileWidgetCollapsed
      event={event}
      sourceFixtureId={sourceFixtureId}
    />
  );
};

export default BetradarWidgetMobile;
